<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-card :flat="!showPageTitle" class="ma-5">
      <page-progress :is-loading="isLoading"/>
      <page-title v-if="showPageTitle" :icon="icon" :title="title"/>
      <v-container class="pt-0" fluid>
        <v-row>
          <v-col cols="12">
            <v-data-table
                v-model="selected"
                :data-scrollable="scrollable"
                :footer-props="{'items-per-page-options': limitList}"
                :headers="headers"
                :hide-default-footer="disableDefaultFooter"
                :disable-pagination="disablePagination"
                :items="data"
                :options.sync="pagination"
                :server-items-length="total"
                :sort-by="sort"
                :sort-desc="descending"
                v-sortable-table
                :show-select="showSelect"
                @sorted="saveOrder"
                class="elevation-1 mt-0"
                dense
            >
              <template v-slot:top>
                <v-toolbar flat class="mb-5">
                  <g-p-search
                      v-if="actions.load"
                      :loading="isLoading"
                      @applySearch="handleSearch"
                  />
                  <add-button
                      v-if="showAddButton"
                      :text="addButtonText"
                      :toolbar="true"
                      @onButtonClick="openPopUp"
                      class="mr-2 mb-6"
                  />
                  <v-spacer/>
                  <GPAutoComplete
                      v-if="isShowClient"
                      :dense="true"
                      :outlined="true"
                      :status=true
                      :validation="false"
                      apiPath="client-types-list"
                      item-text="name"
                      item-value="id"
                      search-label="Select a Client Type"
                      @clearSearchResult="onChangeFilterHandler($event, 'clientType')"
                      @selectSearchResult="onChangeFilterHandler($event, 'clientType')"

                  />
                  <g-filter-autocomplete
                      v-if="showInvoiceButton && showSendMailTemplate"
                      placeholder="Send Mail: Select a Template"
                      :search-items="mailTemplates"
                      @onChangeHandler = "onChangePaymentEmailHandler($event)"
                  />
                  <add-button
                      v-if="showClearButton"
                      :text="clearButtonText"
                      :icon="clearButtonIcon"
                      :toolbar="true"
                      @onButtonClick="clearButtonHandler"
                      class="mr-2 mb-6"
                  />
                </v-toolbar>
                <v-toolbar flat class="mb-5" v-show="showInvoiceButton">
                  <g-date-selector
                      @onChangeDateHandler="onChangeDateHandler"
                      class="mr-2 mb-6"
                  />
                  <g-filter-autocomplete
                      placeholder="Select a User"
                      :search-items="allAdminUsers"
                      @onChangeHandler = "onChangeFilterHandler($event, 'searchUser')"
                  />
                  <g-filter-autocomplete
                      placeholder="Select a Status"
                      :search-items="payStatus"
                      @onChangeHandler = "onChangeFilterHandler($event, 'paymentStatus')"
                  />
                  <g-filter-autocomplete
                      placeholder="Select a Deleted Status"
                      :search-items="dStatus"
                      @onChangeHandler = "onChangeFilterHandler($event, 'deleteStatus')"
                  />

                  <g-filter-autocomplete
                      placeholder="Select a Method"
                      :search-items="allPayMethods"
                      @onChangeHandler = "onChangeFilterHandler($event, 'payMethod')"
                  />
                  <g-p-auto-complete
                      :dense="true"
                      :outlined="true"
                      :status=true
                      :validation="false"
                      apiPath="invoice/get-all-email"
                      item-text="email"
                      item-value="email"
                      search-label="Select a Email"
                      @clearSearchResult="handleClearSearchResult"
                      @selectSearchResult="onSelections"
                  />
                </v-toolbar>
                <v-toolbar flat class="mt-1" v-show="showMailBoxNewsLetter">
                  <v-form ref="mailBoxForm" v-model="valid" lazy-validation style="width: 100% !important; margin-bottom: 20px">
                    <v-row>
                      <v-col cols="12" md="2">
                        <GPAutoComplete
                            :dense="true"
                            :outlined="true"
                            :status=true
                            :validation="true"
                            apiPath="client-types"
                            item-text="name"
                            item-value="id"
                            search-label="Select a Mail Type"
                            @clearSearchResult="onChangeFilterHandler($event, 'clientType')"
                            @selectSearchResult="onChangeFilterHandler($event, 'clientType')"
                        />
                      </v-col>
                      <v-col cols="12" md="3">
                        <g-p-auto-complete
                            :dense="true"
                            :outlined="true"
                            :status=true
                            :validation="true"
                            :search-value="templateType"
                            apiPath="news-letters"
                            search-label="Send Mail: Select a Template"
                            @clearSearchResult="newsLetterTemplateHandler"
                            @selectSearchResult="newsLetterTemplateHandler"
                        />
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-select
                            label="Select a Mail"
                            v-model="mailer"
                            :items="mailSenders"
                            :rules="requiredFieldRule"
                            item-value="id"
                            item-text="name"
                            outlined
                            dense
                        />
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-checkbox
                            v-model="isSendMailToAll"
                            label="Send Mail to All"
                            color="indigo"
                            hide-details
                        />
                      </v-col>
                      <v-col cols="12" md="2">
                        <add-button
                            class="mt-1 mr-2 mb-6"
                            text="Send Mail"
                            icon="mdi-mail"
                            :loading="isNewsletterBtnLoading"
                            @onButtonClick="newsLetterHandler()"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </v-toolbar>
              </template>
              <template v-slot:footer.prepend v-if="showInvoiceButton">
                <v-subheader v-if="user && user.role_id === 1">Grand Total: &nbsp;<strong>${{totalAmount}} USD</strong></v-subheader>
              </template>
              <template v-slot:item.paymentMethod="{ item }">
                <g-avatar v-if="getMethodNormalizedName(item.methods) === 'paddle'" :source="photos.paddle"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'paypal'" :source="photos.paypal"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'stripe'" :source="photos.stripe"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === '2checkout'" :source="photos.checkout"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'bkash'" :source="photos.bKash"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'rocket'" :source="photos.rocket"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'nagad'" :source="photos.nagad"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'bharatpe'" :source="photos.bharatpe"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'dbblbankaccount'" :source="photos.dbbl"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'webmoney'" :source="photos.webmoney"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'payoneer'" :source="photos.payoneer"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'aamarpay'" :source="photos.aamarpay"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'sslcommerz'" :source="photos.sslcommerz"/>
                <g-avatar v-else-if="getMethodNormalizedName(item.methods) === 'usdt'" :source="photos.manual"/>
                <g-avatar v-else :source="photos.methodNotFound"/>
              </template>
              <template v-slot:item.siteUrl="{ item }">
                <v-chip
                    class="ma-2"
                    color="primary"
                    link
                    @click.prevent.stop="openSite(item.siteUrl)"
                >
                  {{ item.siteUrl }}
                </v-chip>
              </template>
              <template v-slot:item.isNew="{ item }">
                <v-checkbox
                  :input-value="item.isNew"
                  @change="checkBoxHandler(item, $event)"
                />
              </template>
              <template v-slot:item.pa="{ item }">
                <progress-circular :value="item.pa" color="primary"/>
              </template>
              <template v-slot:item.da="{ item }">
                <progress-circular :value="item.da" color="teal"/>
              </template>
              <template v-slot:item.dr="{ item }">
                <progress-circular :value="item.dr" color="red"/>
              </template>
              <template v-slot:item.ur="{ item }">
                <progress-circular :value="item.ur" color="pink"/>
              </template>
              <template v-slot:item.status="{ item }">
                <g-payment-status-chip v-if="item.isDeleted" text="Deleted" color="error"/>
                <global-switch-component v-else :current-item="item" @switchHandler="switchHandler"/>
              </template>
              <template v-slot:item.googleNews="{ item }">
                {{ getItemStatus(item.googleNews) }}
              </template>
              <template v-slot:item.follow="{ item }">
                {{ getItemStatus(item.follow) }}
              </template>
              <template v-slot:item.casino="{ item }">
                {{ getItemStatus(item.casino) }}
              </template>
              <template v-slot:item.orderStatus="{ item }">
                <v-btn dark :color="getColor(item.status)">
                  {{ item.status }}
                </v-btn>
              </template>
              <template v-slot:item.date="{ item }">
                {{getDate(item.date)}}
              </template>
              <template v-slot:item.user="{ item }">
                {{item.user.name}}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{getDate(item.createdAt)}}
              </template>
              <template v-slot:item.created_at="{ item }">
                {{getDate(item.created_at)}}
              </template>
              <template v-slot:item.paymentDate="{ item }">
                {{getDate(item.paymentDate)}}
              </template>
              <template v-slot:item.totalAmount="{ item }">
                ${{getInvoiceTotal(item)}}
              </template>
              <template v-slot:item.price="{ item }">
                ${{item.price}}
              </template>
              <template v-slot:item.resellerPrice="{ item }">
                ${{item.resellerPrice}}
              </template>
              <template v-slot:item.resellerAdultPrice="{ item }">
                ${{item.resellerAdultPrice}}
              </template>
              <template v-slot:item.adultPrice="{ item }">
                ${{item.adultPrice}}
              </template>
              <template v-slot:item.adminPrice="{ item }">
                ${{item.adminPrice}}
              </template>
              <template v-slot:item.adminOthersPrice="{ item }">
                ${{item.adminOthersPrice}}
              </template>
              <template v-slot:item.paymentMail="{ item }">
                {{item.paymentMail}}&nbsp; times
              </template>
              <template v-slot:item.isBlocked="{ item }">
                <v-chip
                    v-if="item.isBlocked"
                    class="ma-2"
                    close
                    color="red"
                    text-color="white"
                >
                  Blocked
                </v-chip>
              </template>
              <template v-slot:item.mergedTotal="{ item }">
                ${{getMergedTotal(item)}}
              </template>
              <template v-slot:item.removalMail="{ item }">
                {{item.removalMail}}&nbsp; times
              </template>
              <template v-slot:item.afterRemovalMail="{ item }">
                {{item.afterRemovalMail}}&nbsp; times
              </template>
              <template v-slot:item.settingsName="{ item }">
                {{setGoogleSheetName(item.settingsName)}}
              </template>
              <template v-slot:item.email="{ item }">
                {{item.email}}<v-icon color="orange" title="Fix Client" v-if="item.client && item.client.type === 2">mdi-shield-star</v-icon><v-icon color="primary" title="Special Client" v-else-if="item.client && item.client.type === 3">mdi-shield-account-outline</v-icon><v-icon color="primary" title="Agency Client" v-else-if="item.client && item.client.type === 4">mdi-alpha-a-circle</v-icon>
              </template>
              <template v-slot:item.paymentStatus="{ item }">
                <g-payment-status-chip v-if="item.isDeleted" text="Deleted" color="blue"/>
                <g-payment-status-chip v-else-if="item.paymentStatus === 100"/>
                <g-payment-status-chip v-else-if="item.paymentStatus === 200" color="green" text="Paid"/>
                <g-payment-status-chip v-else-if="item.paymentStatus === 300" color="lime" text="Pending"/>
                <g-payment-status-chip v-else-if="item.paymentStatus === 400" color="green darken-4" text="Refund"/>
                <g-payment-status-chip v-else-if="item.paymentStatus === 600" color="orange" text="Republish"/>
              </template>
              <template v-slot:item.isDeleted="{ item }">
                <g-payment-status-chip v-if="item.isDeleted" text="Deleted" color="blue"/>
              </template>
              <template v-slot:item.refLink="{ item }">
                <v-chip
                    class="ma-2"
                    color="green"
                    text-color="white"
                    link
                    @click.prevent.stop="copyHandler(getRefLink(item.refcode, item.paymentMethod.id))"
                >
                  Copy
                </v-chip>
              </template>
              <template v-slot:item.mergedRefLink="{ item }">
                <v-chip
                    v-if="!item.isDeleted"
                    class="ma-2"
                    color="green"
                    text-color="white"
                    link
                    @click.prevent.stop="copyHandler(getMergedRefLink(item.mergedNo))"
                >
                  Copy
                </v-chip>
              </template>
              <template v-slot:item.user="{ item }">
                {{item.user.name}}
              </template>
              <template v-slot:item.template="{ item }">
                {{item.template.name}}
              </template>
              <template v-slot:item.jobStatus="{ item }">
                <g-payment-status-chip v-if="item.jobStatus === 1" text="Processing"/>
                <g-payment-status-chip v-else-if="item.jobStatus === 2" color="green" text="Completed"/>
                <g-payment-status-chip v-else-if="item.jobStatus === 3" color="lime" text="Canceled"/>
              </template>
              <template v-slot:item.type="{ item }">
                <g-payment-status-chip v-if="item.type === 1" text="Broken Links"/>
                <g-payment-status-chip v-else-if="item.type === 2" color="green" text="Newsletter"/>
                <g-payment-status-chip v-else-if="item.type === 3" color="lime" text="Canceled"/>
              </template>
              <template v-slot:item.actions="{item}">
                <row-action-menu-button
                    :action-columns="actionColumns"
                    :column="item"
                    :row="item"
                    :user="user"
                    @actionButtonClick="handleActionButtonClick"/>
              </template>
              <template v-slot:item.siteOwnerId="{ item }">
                {{item.siteOwner && item.siteOwner.name ? item.siteOwner.name : ''}}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <component
        :is="popupComponent"
        ref="component"
        :basic-data="basicData"
        :item="editedItem"
        :show="showPopup"
        @closePopupHandler="closePopupHandler"
        @onPopupShow="openPopUp"
        @saveItemHandler="saveItemHandler"
    />
    <confirm-popup
        :show="showConfirm"
        confirm-event="onConfirmSync"
        @closePopupHandler="showConfirm = false"
        @onConfirmSync="syncItem(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to sync DR, Traffic etc in google sheet?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showConfirmMoz"
        confirm-event="onConfirmSyncMoz"
        @closePopupHandler="showConfirmMoz = false"
        @onConfirmSyncMoz="syncItemMoz(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to sync DA, PA in google sheet?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showDeleteConfirm"
        confirm-event="onConfirmDelete"
        @closePopupHandler="showDeleteConfirm = false"
        @onConfirmDelete="deleteItem(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to delete this item permanently?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showSoftDeleteConfirm"
        confirm-event="onConfirmDelete"
        @closePopupHandler="showSoftDeleteConfirm = false"
        @onConfirmDelete="softDeleteHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to delete this item?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showRestoreConfirm"
        confirm-event="onConfirmRestore"
        @closePopupHandler="showRestoreConfirm = false"
        @onConfirmRestore="restoreHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to restore<span v-if="currentSelectedItem && currentSelectedItem.refcode">({{currentSelectedItem.refcode}})</span> this item?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showResendMailConfirm"
        confirm-event="onConfirmResendMail"
        @closePopupHandler="showResendMailConfirm = false"
        @onConfirmResendMail="resendPaymentMailHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to send email to this mail ID: <span v-if="currentSelectedItem && currentSelectedItem.email">{{currentSelectedItem.email}}</span>?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showResetInvoiceConfirm"
        confirm-event="onConfirmResetInvoice"
        @closePopupHandler="showResetInvoiceConfirm = false"
        @onConfirmResetInvoice="onResetInvoiceHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to reset<span v-if="currentSelectedItem && currentSelectedItem.refcode">({{currentSelectedItem.refcode}})</span> all the payment information?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showAfterReminderMailConfirm"
        confirm-event="onConfirmAfterReminderMail"
        @closePopupHandler="showAfterReminderMailConfirm = false"
        @onConfirmAfterReminderMail="afterReminderPaymentMailHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to send email to this mail ID: <span v-if="currentSelectedItem && currentSelectedItem.email">{{currentSelectedItem.email}}</span>?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showReminderMailConfirm"
        confirm-event="onConfirmResendMail"
        @closePopupHandler="showReminderMailConfirm = false"
        @onConfirmResendMail="reminderPaymentMailHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to send reminder payment email to this mail ID: <span v-if="currentSelectedItem && currentSelectedItem.email">{{currentSelectedItem.email}}</span>?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showRepublishConfirm"
        confirm-event="onConfirmRepublish"
        @closePopupHandler="showRepublishConfirm = false"
        @onConfirmRepublish="republishHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to republish all the articles of this order ID: <span v-if="currentSelectedItem && currentSelectedItem.invoiceNo">{{currentSelectedItem.invoiceNo}} and the provided email ID: {{currentSelectedItem.email}}  </span>?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showMailConfirm"
        confirm-event="onConfirmMail"
        @closePopupHandler="showMailConfirm = false"
        @onConfirmMail="onChangePaymentEmailHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to send <strong v-if="currentSelectedItem && currentSelectedItem.name">{{currentSelectedItem.name}}</strong> to all selected items?</span>
      </div>
    </confirm-popup>
    <files-popup :show="showFilesPopup" :item="editedItem" @closePopupHandler="closePopupHandler"/>
    <link-popup :show="showLinkPopup" :item="editedItem" @closePopupHandler="closePopupHandler"/>
    <merged-link-popup :show="showMergedLinkPopup" :item="editedItem" @closePopupHandler="closePopupHandler"/>
    <manual-payment-popup
        :show="showManualPaymentPopup"
        :item="editedItem"
        @saveItemHandler="saveItemHandler"
        @closePopupHandler="closePopupHandler"
    />
    <manual-payment-merged-popup
        :show="showManualMergedPaymentPopup"
        :item="editedItem"
        @saveItemHandler="saveItemHandler"
        @closePopupHandler="closePopupHandler"
    />
    <email-details-popup :show="showEmailTimeliner" :item="editedItem" @closePopupHandler="closePopupHandler"/>
    <confirm-popup
        :show="showMergedMailConfirm"
        confirm-event="onConfirmMergedMail"
        @closePopupHandler="showMergedMailConfirm = false"
        @onConfirmMergedMail="resendMergedMailHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to send email to this mail ID: <span v-if="currentSelectedItem && currentSelectedItem.email">{{currentSelectedItem.email}}</span>?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showMergedUpdateMailConfirm"
        confirm-event="onConfirmUpdateMergedMail"
        @closePopupHandler="showMergedUpdateMailConfirm = false"
        @onConfirmUpdateMergedMail="updateMergedMailHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to send email to this mail ID: <span v-if="currentSelectedItem && currentSelectedItem.email">{{currentSelectedItem.email}}</span>?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showRefundConfirm"
        confirm-event="onConfirmRefund"
        @closePopupHandler="showRefundConfirm = false"
        @onConfirmRefund="refundInvoiceHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to refund<span v-if="currentSelectedItem && currentSelectedItem.refcode">({{currentSelectedItem.refcode}})</span> this item?</span>
      </div>
    </confirm-popup>
    <confirm-popup
        :show="showRepublishMailConfirm"
        confirm-event="onConfirmRepublishMail"
        @closePopupHandler="showRepublishMailConfirm = false"
        @onConfirmRepublishMail="republishedMailHandler(currentSelectedItem, true)"
    >
      <div>
        <span>Are you sure to send article republish email to this mail ID: <span v-if="currentSelectedItem && currentSelectedItem.email">{{currentSelectedItem.email}}</span>?</span>
      </div>
    </confirm-popup>
  </div>
</template>

<script>
import PageTitle from "./PageTitle";
import PageProgress from "./PageProgress";
import ConfirmPopup from "./popups/ConfirmPopup";
import SaveButton from "./buttons/SaveButton";
import RowActionMenuButton from "./RowActionMenuButton";
import AddButton from "./buttons/AddButton";
import GPSearch from "./GPSearch";
import ProgressCircular from "./ProgressCircular";
import ListPageMixin from "./mixins/listpage/ListPageMixin";
import GlobalSwitchComponent from "./GlobalSwitchComponent";
import FilesPopup from "./popups/FilesPopup";
import LinkPopup from "./popups/LinkPopup";
import mailTemplate from '../json/mailTemplate.json'
import Button from "./mixins/Button";
import ManualPaymentPopup from "./popups/ManualPaymentPopup";
import GPaymentStatusChip from "./GPaymentStatusChip";
import GAvatar from "./GAvatar";
import GDateSelector from "./calendar/GDateSelector";
import GFilterAutocomplete from "./GFilterAutocomplete";
import GPAutoComplete from "./GPAutoComplete";
import EmailDetailsPopup from "./popups/EmailDetailsPopup";
import ManualPaymentMergedPopup from "@/components/popups/ManualPaymentMergedPopup";
import MergedLinkPopup from "@/components/popups/MergedLinkPopup";

export default {
  name: "ListPage",
  mixins: [ListPageMixin],
  data() {
    return {
      mailTemplate: mailTemplate,
      photos: {
        paddle: require('../assets/img/pay/paddle.jpg'),
        aamarpay: require('../assets/img/pay/bd-payment.png'),
        sslcommerz: require('../assets/img/pay/bd-payment.png'),
        paypal: require('../assets/img/pay/paypal.jpg'),
        stripe: require('../assets/img/pay/stripe.jpg'),
        checkout: require('../assets/img/pay/2checkout.jpg'),
        bKash: require('../assets/img/pay/bkash.png'),
        rocket: require('../assets/img/pay/rocket.png'),
        nagad: require('../assets/img/pay/nagad.png'),
        bharatpe: require('../assets/img/pay/bharatpe.jpg'),
        webmoney: require('../assets/img/pay/webmoney.jpg'),
        dbbl: require('../assets/img/pay/dutch-bangla-bank.jpg'),
        payoneer: require('../assets/img/pay/payoneer.png'),
        manual: require('../assets/img/pay/manual.png'),
        methodNotFound: require('../assets/img/pay/method-not-found.png'),
      }
    }
  },
  components: {
    MergedLinkPopup,
    ManualPaymentMergedPopup,
    EmailDetailsPopup,
    GPAutoComplete,
    GFilterAutocomplete,
    GDateSelector,
    GPaymentStatusChip,
    ManualPaymentPopup,
    Button,
    LinkPopup,
    FilesPopup,
    GlobalSwitchComponent,
    ProgressCircular,
    GPSearch,
    AddButton,
    RowActionMenuButton,
    SaveButton,
    ConfirmPopup,
    PageProgress,
    PageTitle,
    GAvatar
  },
  methods: {
    getRefLink(refcode, method='') {
       const api = process.env.VUE_APP_BASE_URL;
       if(Number(method) === 12){
         return `${api}/direct-bd-payment?refno=${refcode}`;
       }
      if(Number(method) === 13){
        return `${api}/payment/checkout?refno=${refcode}`;
      }
       return `${api}/payment?refno=${refcode}`;
     },
    getMergedRefLink(mergedNo) {
      const api = process.env.VUE_APP_BASE_URL;
      return `${api}/payment?refno=${mergedNo}`;
    },
    getMailTemplate(item) {
      let template = this.setMailTemplate(item);
      this.copyClipboard(template);
    },
    setMailTemplate(item) {
     return `
          ${this.mailTemplate.title}

          ${this.mailTemplate.liveLinkText}: ${this.getRefLink(item.refcode)}

          ${this.mailTemplate.stepTitle}

          ${this.getSteps()}`;
    },
    getSteps() {
      let step = "";
      this.mailTemplate.steps.forEach(item=> {
        step += item + '\n'
      })
      return step;
    },
    copyHandler(linkUrl) {
      this.copyClipboard(linkUrl);
    },
    copyClipboard(text) {
      const me = this;
      this.$copyText(text).then(function (e) {
        me.setSnackBar({text: 'Clipboard Copied!', type: 'info'})
      }, function (e) {
        me.setSnackBar({text: 'Can not Copied!', type: 'error'})
      })
    }
  }
}
</script>

<style>

/*.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 32px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}*/
/*.select-field .v-text-field__details {
  padding-top: 0px;
  margin-bottom: 0px;
  display: none;
}*/

.price-field .v-input {
  max-width: 200px;
  float: right;
  align-items: center;
}

.discount-field .v-text-field__details {
  padding-top: 0px !important;
  margin-bottom: 0px !important;
  display: none;
}

</style>
